import { widgetWrappersCollection } from '@it-enterprise/web-app-common/src/tools/widgetWrapper/widgetWrappersCollection'

export class WidgetsApi {
  GetWidgetByName(name) {
    for (const key in widgetWrappersCollection) {
      if (widgetWrappersCollection[key].UniqueName === name) {
        return widgetWrappersCollection[key]
      }
    }

    console.warn(`Warning: Can't find widget with name "${name}"`)
    return null
  }

  GetWidgetById(id) {
    for (const key in widgetWrappersCollection) {
      if (key === id) {
        return widgetWrappersCollection[key]
      }
    }

    console.warn(`Warning: Can't find widget with id "${id}"`)
    return null
  }
}